import React from "react";
import { FashionProductCard, ProductCardSkeleton } from "@/components/FashionProductCard";

export function FashionProductGrid({ products, loading, columns = 4 }) {
  if (loading) {
    return (
      <div className="fashion-grid-4">
        {Array.from({ length: columns * 2 }).map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (!products?.length) {
    return (
      <div className="text-center py-20">
        <p className="font-display text-xl text-fashion-text-muted">No products found</p>
        <p className="text-sm text-fashion-text-light mt-2">Try adjusting your filters or search terms</p>
      </div>
    );
  }

  return (
    <div className="fashion-grid-4">
      {products.map((p) => (
        <FashionProductCard key={p._id || p.id} product={p} />
      ))}
    </div>
  );
}
